<template>
  <div>
    <b-modal
      id="modal_form"
      ref="modal_form"
      :title="modal_titulo"
      :ok-title="modal_botao"
      close-title="Fechar"
      no-close-on-backdrop
      v-model="showModal"
      :ok-disabled="form.errors.any()"
      @ok="onGerarDocumento"
    >
      <form
        @submit.stop.prevent="handleOk"
        @keydown="form.errors.clear($event.target.name)"
      >
        <div class="loadingDataPosition">
          <div class="loadingData" v-if="loading">
            <div class="loadingDataSpinner">
              <spinner
                v-if="loading"
                text-fg-color="#ffffff"
                message="Carregando..."
              ></spinner>
            </div>
          </div>
          <div class="col-md-12 col-sm-12">
            <span>
              <label
                >Total de documentos selecionados:
                {{ this.docfis.length }}</label
              >
            </span>
            <!-- <span v-if="this.exibeFiltros == true">
              <label
                >Total de documentos selecionados:
                {{
                  this.$parent.$refs.paginationInfo.tablePagination.total
                }}</label
              >
            </span> -->
            <b-form-feedback
              v-text="form.errors.get('docfis')"
              v-if="form.errors.has('docfis')"
            ></b-form-feedback>
            <br /><br />
            <div v-if="this.exibeFiltros == true">
              <h4>Filtros Aplicados:</h4>
              <!-- <span>{{this.$parent.$parent.$refs.pagination.tablePagination}}</span> -->
              <span v-if="this.form.data_filter.num_fiscal != ''"
                >N° Fiscal NFe: {{ this.form.data_filter.num_fiscal }}<br
              /></span>
              <span v-if="this.form.data_filter.chave != ''"
                >Chave NFe: {{ this.form.data_filter.chave }}<br
              /></span>
              <span v-if="this.form.data_filter.num_fiscal_doc != ''"
                >N° Fiscal CTe: {{ this.form.data_filter.num_fiscal_doc }}<br
              /></span>
              <span v-if="this.form.data_filter.emi_cnpj != ''"
                >Cnpj Emitente: {{ this.form.data_filter.emi_cnpj }}<br
              /></span>
              <span v-if="this.form.data_filter.usuario_inc != ''"
                >Email do Usuário Inclusão:
                {{ this.form.data_filter.usuario_inc }}<br
              /></span>
              <span v-if="this.form.data_filter.dt_inc_inicio"
                >Dt.Inclusão Inicial: {{ this.form.data_filter.dt_inc_inicio
                }}<br
              /></span>
              <span v-if="this.form.data_filter.dt_inc_fim"
                >Dt.Inclusão Final: {{ this.form.data_filter.dt_inc_fim }}<br
              /></span>
              <span v-if="this.form.data_filter.dt_inicio != ''"
                >Dt.Emissão Inicial: {{ this.form.data_filter.dt_inicio }}<br
              /></span>
              <span v-if="this.form.data_filter.dt_fim != ''"
                >Dt.Emissão Final: {{ this.form.data_filter.dt_fim }}<br
              /></span>
              <span v-if="this.form.data_filter.ocultar != ''"
                >Ocultados: Sim<br
              /></span>
              <span v-if="this.form.data_filter.utilizadas != ''"
                >Utilizadas: Sim<br
              /></span>
              <span v-if="this.form.data_filter.canceladas != ''"
                >Canceladas: Sim<br
              /></span>
              <span v-if="this.form.data_filter.redespacho == '1'"
                >Redespacho: Sim<br/>
              </span>
            </div>
            <br />
            <label>Processo</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.tp_processo"
                :options="this.$parent.optionsLivTpProcesso"
                name="tp_processo"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('tp_processo')"
              v-if="form.errors.has('tp_processo')"
            ></b-form-feedback>
            <b-col
              v-if="this.form.tp_processo == 2 || this.form.tp_processo == 3 || this.form.tp_processo == 6 || this.form.tp_processo == 7"
            >
              <b-row>
                <b-col class="p-0">
                  <label>Unidade Devolução</label>
                  <multiselect
                      v-model="destinatarioSelected"
                      :options-limit="300"
                      :limit="2"
                      :limit-text="limitText"
                      :options="optionsDestinatario"
                      track-by="value"
                      label="label"
                      :hide-selected="true"
                      placeholder="Destinatário ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                      tag-placeholder="Selecionar"
                      select-label="Selecionar"
                      selected-label="Selecionado"
                      deselect-label="Remover"
                      :searchable="true"
                      :loading="isLoadingDest"
                      @search-change="listaClientesDestinatario"
                  ></multiselect>
                  <b-form-feedback
                      class="text-danger"
                      v-text="form.errors.get('destinatario_id')"
                      v-if="form.errors.has('destinatario_id')"
                  ></b-form-feedback>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="p-0">
                  <label>Recebedor</label>
                  <multiselect
                      v-model="recebedorSelected"
                      :options-limit="300"
                      :limit="2"
                      :limit-text="limitText"
                      :options="optionsRecebedor"
                      track-by="value"
                      label="label"
                      :hide-selected="true"
                      placeholder="Recebedor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                      tag-placeholder="Selecionar"
                      select-label="Selecionar"
                      selected-label="Selecionado"
                      deselect-label="Remover"
                      :searchable="true"
                      :loading="isLoadingRec"
                      @search-change="listaClientesRecebedor"
                  ></multiselect>
                  <b-form-feedback
                      class="text-danger"
                      v-text="form.errors.get('recebedor_id')"
                      v-if="form.errors.has('recebedor_id')"
                  ></b-form-feedback>
                </b-col>
              </b-row>

              <b-row>
                <b-col class="p-0">
                  <label>Tomador</label>
                  <b-form-radio-group
                    v-model="form.tp_tomador"
                    name="tp_tomador"
                  >
                    <b-row>
                      <!-- <b-col>
                        <b-form-radio value="0"> Remetente</b-form-radio>
                      </b-col>
                      <b-col>
                        <b-form-radio value="1"> Expedidor</b-form-radio>
                      </b-col>
                      <b-col>
                        <b-form-radio value="2"> Recebedor</b-form-radio>
                      </b-col>
                      <b-col>
                        <b-form-radio value="3"> Destinatário</b-form-radio>
                      </b-col> -->
                      <b-col>
                        <b-form-radio value="4"> Outros</b-form-radio>
                      </b-col>
                    </b-row>
                  </b-form-radio-group>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('tp_tomador')"
                    v-if="form.errors.has('tp_tomador')"
                  ></b-form-feedback>
                </b-col>
              </b-row>
              <b-row v-if="form.tp_tomador == 4">
                <b-col class="p-0">
                  <label>Tomador - Outros</label>
                  <multiselect
                    v-model="tomadorOutrosSelected"
                    :options-limit="300"
                    :limit="2"
                    :limit-text="limitText"
                    :options="optionsTomador"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Tomador ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    :searchable="true"
                    :loading="isLoadingTom"
                    @search-change="listaClientesTomador"
                  ></multiselect>
                </b-col>
              </b-row>
              <b-row>
                <b-form-feedback
                  class="text-danger"
                  v-text="form.errors.get('tomador_id')"
                  v-if="form.errors.has('tomador_id')"
                ></b-form-feedback>
              </b-row>
            </b-col>
            <label>Operação</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.tp_operacao"
                :options="this.$parent.optionsLivTpOperacao"
                name="tp_operacao"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('tp_operacao')"
              v-if="form.errors.has('tp_operacao')"
            ></b-form-feedback>

            <!-- <label>Conferência na expedição</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.exige_conferencia_exp"
                :options="this.$parent.optionsLivExigeConferenciaExp"
                name="exige_conferencia_exp"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('exige_conferencia_exp')"
              v-if="form.errors.has('exige_conferencia_exp')"
            ></b-form-feedback> -->
          </div>
        </div>
      </form>

      <div slot="modal-footer" class="w-100">
        <div class="float-left">
          <spinner v-if="loading" message="Processando..."></spinner>
          <div
            v-if="this.docfis.length >= 500 && this.docfis.length < 1000"
            style="
              background-color: #ffc107;
              height: 10%;
              width: 100%;
              margin-bottom: 10px;
              padding: 5px;
              display: flex;
              border-radius: 8px;
            "
          >
            Atenção: foram selecionados mais de 500 registros, Deseja
            confirmação ação?
          </div>
          <div
            v-if="this.docfis.length >= 1000"
            style="
              background-color: #dc3545;
              color:#ffffff;
              height: 10%;
              width: 100%;
              margin-bottom: 10px;
              padding: 5px;
              display: flex;
              border-radius: 8px;
            "
          >
            Atenção: foram selecionados mais de 1000 registros, Não é possivel
            prosseguir com a ação
          </div>
        </div>
        <div class="float-right">
          <div class="float-left" v-if="this.errors_array.length > 0">
            <b-btn
              class="badge badge-warning"
              @click="showPopover = !showPopover"
              id="popoverButton-sync"
              v-b-tooltip.hover.left="
                'Clique aqui para ver os erros encontrados'
              "
              variant="warning"
              ><i class="fa fa-exclamation-triangle fa-2x"></i
            ></b-btn>

            <b-popover
              :show.sync="showPopover"
              target="popoverButton-sync"
              title="<strong>Erros Encontrados</strong>"
              data-html="true"
              placement="leftbottom"
            >
              <table class="table" id="mais">
                <tbody>
                  <tr
                    class="bg-gray-light"
                    style="display: table-row"
                    v-for="item in this.errors_array"
                  >
                    <td>
                      {{ item.erro }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-popover>
          </div>

          <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
          <b-btn
            @click="onGerarDocumento($event)"
            variant="secondary"
            :disabled="isDisabled"
          >
            Enviar
          </b-btn>
        </div>
      </div>
    </b-modal>
    <!-- Nota presa como "em geração". Ver TMS-8776 -->
    <GerarDocNotaTravadaModal
      ref="notaTravada"
      @gerado="onNotaTravadaGerada"
      @atualizar="onNotaTravadaGerada"
    ></GerarDocNotaTravadaModal>
  </div>
</template>
<script>
import GerarCteForm from "./GerarCteForm";
import GerarDocNotaTravadaModal from "./GerarDocNotaTravadaModal";

import { formatCNPJFromParts } from "../utils";
import { escaparHtml, mensagemAlertaHtml } from "../utils/alertaHtml";

export default {
  components: {
    GerarCteForm,
    GerarDocNotaTravadaModal,
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      exibeFiltros: false,
      optionsRecebedor: [],
      optionsDestinatario: [],
      optionsTomador: [],
      tomadorOutrosSelected: [],
      recebedorSelected: [],
      destinatarioSelected: [],
      loading: false,
      isLoadingRec: false,
      isLoadingDest: false,
      isLoadingTom: false,
      isDisabled: false,
      showModal: false,
      docfis: [],
      errors_array: [],
      data_filter: {},
      form: new Form({
        data_filter: {},
        tp_processo: 1,
        tp_operacao: 1,
        recebedor_id: "",
        destinatario_id: "",
        tp_tomador: "",
        tomador_id: "",
        exige_conferencia_exp: 2,
        docfis: [],
      }),
      helpForm: new Form({
        search: "",
      }),
      // TMS-6449 — formularios dedicados ao alerta de redespacho a parceiro.
      // Sao instancias proprias, e nao `this.form`, de proposito: um 422 no
      // pre-check gravaria erros em `form.errors`, que alimenta o
      // `:ok-disabled="form.errors.any()"` do modal e os `b-form-feedback`.
      // O alerta nao pode sujar o estado do formulario de emissao.
      alertaParceiroForm: new Form({
        tp_operacao: "",
        docfis: [],
      }),
      alertaParceiroRespostaForm: new Form({
        tp_operacao: "",
        resposta: "",
        docfis: [],
      }),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    recebedorSelected(obj) {
      this.form.recebedor_id = obj.value;
    },
    tomadorOutrosSelected(obj) {
      this.form.tomador_id = obj.value;
    },
    destinatarioSelected(obj) {
      this.form.destinatario_id = obj.value;
    },
  },
  methods: {
    onCreate(data_filter, tipo) {
      this.isDisabled = false;
      this.loading = true;
      this.modal_titulo = "Gerar documento";
      this.modal_botao = "Gerar";
      this.modal_acao = "i";
      this.form.reset();
      this.exibeFiltros = false;
      if (JSON.stringify(data_filter) != "{}") {
        this.form.data_filter = data_filter;
        this.exibeFiltros = true;
      }
      this.tomadorOutrosSelected = [];
      this.form.tp_tomador = 4;
      this.recebedorSelected = [];
      this.destinatarioSelected = [];
      this.form.docfis = null;
      this.form.docfis = [];
      this.docfis = null;
      this.docfis = [];
      this.$parent.$refs.vuetable.selectedTo.forEach((docfis_id) => {
        // this.$parent.$refs.vuetable.tableData.forEach(obj => {
        //if (obj.docfis_id == docfis_id) {
        this.docfis.push({ docfis_id: docfis_id });
        //}
        //});
      });
      if (this.docfis.length >= 1000) {
        this.isDisabled = true;
      }
      this.loading = false;
      this.$refs.modal_form.show();
    },
    onGerarDocumento() {
      var vm = this;
      this.form.tp_orig_doc = 3; // Gerar Doc
      this.form.docfis = this.docfis;

      var mensagem =
        "Redespacho (Razão social) cadastrado como retira, tipo de processo informado é diferente, deseja continuar a emissão de CTe?";

      const onConfirmUnitWrapper = () => {
        confirmAcao(vm);
      };

      // TMS-6449/RN-19 — retira primeiro, parceiro depois. "Sim" no alerta de
      // retira encadeia o pre-check de parceiro antes de emitir. "Não" no alerta
      // de retira encerra o fluxo e o pre-check NAO roda: so se registra alerta
      // que foi efetivamente exibido ao operador.
      const onConfirmRetiraWrapper = () => {
        vm.verificarAlertaParceiro(() => {
          confirmAcao(vm);
        });
      };

      let confirmAcao = function(vm) {
        vm.loading = true;
        vm.isDisabled = true;
        vm.form
          .post("/api/gerardoc/store")
          .then((response) => {
            if (!vm.onRespostaNotaTravada(response)) {
              new ReturnApi(response, vm);
            }
            vm.$parent.onFilterReset();
          })
          .catch((errors) => {
            new ReturnApi(errors, vm, true, null, null, false);
            vm.errors_array = "";
            vm.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    vm.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
          });
      };

      // TMS-6449 — a emissao do ramo `tp_processo == 4`, extraida para funcao
      // porque agora tem dois pontos de entrada: direto (quando `this.metodo`
      // esta definido) e depois do pre-check de parceiro. O corpo e o mesmo de
      // antes, linha a linha.
      let confirmAcaoProcesso4 = function(vm) {
        vm.loading = true;
        vm.isDisabled = true;
        vm.form
          .post("/api/gerardoc/store")
          .then((response) => {
            if (!vm.onRespostaNotaTravada(response)) {
              new ReturnApi(response, vm);
            }
            if (vm.metodo != null) {
              vm.metodo();
            } else {
              vm.$parent.onFilterReset();
            }
          })
          .catch((errors) => {
            new ReturnApi(errors, vm);
            if (vm.metodo != null) {
              vm.metodo();
            } else {
              vm.$parent.onFilterReset();
            }
            vm.$parent.$refs.vuetable.selectedTo = [];
            // Antes este bloco ficava fora do catch e lançava ReferenceError
            // (errors/property indefinidos). Ver TMS-8776.
            vm.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (Array.isArray(errors[property])) {
                  errors[property].forEach((obj) => {
                    vm.errors_array.push({ erro: obj });
                  });
                }
              }
            }
          });
      };

      let obj = {
        title: "Confirmar Expedição ?",
        message: mensagem,
        customConfirmBtnText: "Sim",
        customCloseBtnText: "Não",
        type: "info",
        useConfirmBtn: true,
        onConfirm: onConfirmUnitWrapper,
      };

      if (this.form.tp_processo != 4) {
        vm.loading = true;
        vm.isDisabled = true;
        this.form
          .post("/api/gerardoc/isretira")
          .then((response) => {
            new ReturnApi(response, this);
            if (this.metodo != null) {
              this.metodo();
            } else {
              if (response.transportadora_retira != null) {
                obj = {
                  title: "Confirmar Geração de Documento ?",
                  // SEC-01 — `transportadora_retira` e razao social crua de
                  // `pessoa_juridica` e a `message` do Simplert e innerHTML.
                  // Mesmo vetor do alerta de parceiro, mesmo tratamento. O
                  // texto exibido nao muda: a razao social nao tem marcacao.
                  message:
                    "Redespacho " +
                    escaparHtml(response.transportadora_retira) +
                    " cadastrado como retira, tipo de processo informado é diferente, deseja continuar a emissão de CTe?",
                  customConfirmBtnText: "Sim",
                  customCloseBtnText: "Não",
                  type: "info",
                  useConfirmBtn: true,
                  onConfirm: onConfirmRetiraWrapper,
                };
                console.log("Passou aqui 1");
                this.$Simplert.open(obj);
              } else {
                // TMS-6449 — sem alerta de retira, o pre-check de parceiro e o
                // unico a decidir se a emissao segue direto.
                this.verificarAlertaParceiro(() => {
                  confirmAcao(vm);
                });
              }
            }
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
            this.errors_array = "";
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({ erro: obj });
                  });
                }
              }
            }
          });
      } else {
        // TMS-6449/D1 — o pre-check de parceiro NAO herda o gate de
        // `tp_processo`. Aqui nao existe `isretira`, mas o alerta de parceiro
        // depende apenas de `tp_operacao = 2`. Medicao de 7 dias: 193 documentos
        // com `tp_processo = 4` e `tp_operacao = 2` com redespacho a parceira
        // ativa ficariam sem alerta se ele rodasse so no ramo de cima.
        //
        // D5/R2 — o guard de `this.metodo` vale aqui do mesmo jeito que no ramo
        // do alerta de retira: fora dele, o alerta de parceiro apareceria em
        // contextos nos quais o de retira nunca aparece.
        if (this.metodo != null) {
          confirmAcaoProcesso4(vm);
        } else {
          this.verificarAlertaParceiro(() => {
            confirmAcaoProcesso4(vm);
          });
        }
      }
    },
    /**
     * Pre-check do alerta de redespacho a parceiro (TMS-6449).
     *
     * Consulta `POST /api/gerardoc/alerta-parceiro` com a MESMA selecao que iria
     * para o `store`. Sem alerta, segue direto para `onSemAlerta`. Com alerta,
     * abre o modal de confirmacao reusando o componente do alerta de retira
     * (vue2-simplert-plugin), com os botoes "Sim" e "Não".
     *
     * O `titulo` e a `mensagem` vem PRONTOS do backend: o front nao concatena
     * razao social, nao formata CNPJ e nao conta parceiros (ADR-0013, D1).
     *
     * Falha do pre-check nao trava a emissao — o `.catch` segue para
     * `onSemAlerta`, que e exatamente o fluxo anterior a esta entrega. Falhar
     * fechado criaria um modo de falha novo para 100% das emissoes por conta de
     * um aviso que, por definicao, e opcional.
     *
     * Nao chama `ReturnApi` de proposito: o comportamento padrao dele recarrega
     * a vuetable quando o HTTP e 200, e nada aqui pede refresh da lista.
     *
     * @param {Function} onSemAlerta acao de emissao a executar quando liberado
     */
    verificarAlertaParceiro(onSemAlerta) {
      var vm = this;

      vm.loading = true;
      vm.isDisabled = true;
      vm.alertaParceiroForm.tp_operacao = vm.form.tp_operacao;
      vm.alertaParceiroForm.docfis = vm.form.docfis;

      vm.alertaParceiroForm
        .post("/api/gerardoc/alerta-parceiro")
        .then((response) => {
          vm.loading = false;
          vm.isDisabled = false;

          var alerta = null;
          if (response != null && response.alerta != null) {
            alerta = response.alerta;
          }

          if (alerta == null) {
            onSemAlerta();
            return;
          }

          vm.$Simplert.open({
            title: alerta.titulo,
            // A `message` do Simplert e injetada como innerHTML, entao o `\n` da
            // copy de multiplos parceiros nao quebra linha sozinho. O wrapper
            // aplica `white-space: pre-line` e o texto do backend entra
            // ESCAPADO (SEC-01): a mensagem carrega razao social de pessoa
            // juridica, que e campo livre. Escapar aqui, no sink, e nao na
            // origem — a mesma string e gravada em `doc_fiscal_log` e exibida
            // na aba Erros com `{{ }}`, onde entidade HTML apareceria literal.
            message: mensagemAlertaHtml(alerta.mensagem),
            customConfirmBtnText: "Sim",
            customCloseBtnText: "Não",
            type: "info",
            useConfirmBtn: true,
            onConfirm: () => {
              vm.registrarRespostaAlerta("S", () => {
                onSemAlerta();
              });
            },
            onClose: () => {
              vm.registrarRespostaAlerta("N", () => {
                // RN-13 — o "Não" cancela a emissao mas PRESERVA a selecao: sem
                // `onFilterReset()`, sem limpar `selectedTo`, sem recarregar a
                // lista. O operador corrige a operacao e reenvia.
                vm.loading = false;
                vm.isDisabled = false;
              });
            },
          });
        })
        .catch(() => {
          vm.loading = false;
          vm.isDisabled = false;
          onSemAlerta();
        });
    },
    /**
     * Registra no backend a resposta do operador ao alerta de parceiro.
     *
     * CA-05 — o rastro do aviso NAO pode depender de a emissao ocorrer: este
     * metodo e chamado nos dois caminhos, "Sim" e "Não". No "Sim" o registro vai
     * ANTES do `store`, para que o rastro ja exista se a emissao quebrar depois.
     *
     * `depois` roda com sucesso OU com falha do registro: o resultado da
     * auditoria e irrelevante para o operador e nunca pode bloquear a emissao
     * (ADR-0013, D1). O endpoint responde 200 em todo caso de negocio.
     *
     * O endpoint NAO aceita a mensagem — manda-se a selecao e a resposta, e o
     * backend recomputa o texto. Enviar texto daqui nao mudaria nada do que e
     * gravado, e e justamente o que impede forja de auditoria.
     *
     * @param {String}   resposta "S" para Sim, "N" para Não
     * @param {Function} depois   acao a executar depois do registro
     */
    registrarRespostaAlerta(resposta, depois) {
      var vm = this;

      vm.alertaParceiroRespostaForm.tp_operacao = vm.form.tp_operacao;
      vm.alertaParceiroRespostaForm.docfis = vm.form.docfis;
      vm.alertaParceiroRespostaForm.resposta = resposta;

      vm.alertaParceiroRespostaForm
        .post("/api/gerardoc/alerta-parceiro/resposta")
        .then(() => {
          depois();
        })
        .catch(() => {
          depois();
        });
    },
    /**
     * Store devolveu nota presa como "em geração" (code GERARDOC_INVOICE_LOCKED):
     * fecha a geração e abre o modal com as ações em vez do alerta do ReturnApi.
     * Ver TMS-6446 / TMS-8776.
     */
    onRespostaNotaTravada(response) {
      if (
        !response ||
        response.code !== "GERARDOC_INVOICE_LOCKED" ||
        !response.locked_invoice
      ) {
        return false;
      }
      this.loading = false;
      this.isDisabled = false;
      this.showModal = false;
      this.$refs.notaTravada.abrir(response, this.form.data());
      return true;
    },
    onNotaTravadaGerada() {
      this.$parent.onFilterReset();
    },
    listaClientesRecebedor(search) {
      if (search.length >= 3) {
        this.isLoadingRec = true;
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then((response) => {
            this.optionsRecebedor = [];
            new ReturnApi(response, this, true, false, false);
            response.items.forEach((obj) => {
              this.optionsRecebedor.push({
                label:
                  obj.pessoa.cd +
                  " - " +
                  obj.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ) +
                  " - " +
                  obj.inscricao_estadual,
                value: obj.pessoa_id,
              });
            });
            this.isLoadingRec = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    listaClientesTomador(search) {
      if (search.length >= 3) {
        this.isLoadingTom = true;
        this.helpForm.search = search;
        this.helpForm
          .post("/api/pessoa/jsonlist")
          .then((response) => {
            this.optionsTomador = [];
            new ReturnApi(response, this, true, false, false);
            response.items.forEach((obj) => {
              this.optionsTomador.push({
                label:
                  obj.pessoa.cd +
                  " - " +
                  obj.razao_social +
                  " - " +
                  this.onFormataCnpj(
                    obj.cnpj_base,
                    obj.cnpj_filial,
                    obj.cnpj_digito
                  ) +
                  " - " +
                  obj.inscricao_estadual,
                value: obj.pessoa_id,
              });
            });
            this.isLoadingTom = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    listaClientesDestinatario(search) {
      if(search.length>=3)
      {
        this.isLoadingDest = true;
        // this.isLoadingTom2 = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm.post('/api/unidade/jsonlist').then(response =>
        {
          this.optionsDestinatario = [];
          new ReturnApi(response, this, true, false, false);
          response.items.forEach((obj)=>
          {
            this.optionsDestinatario.push({ label: obj.cd+" - "+obj.pessoa.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(obj.pessoa.pessoa_juridica.cnpj_base,obj.pessoa.pessoa_juridica.cnpj_filial,obj.pessoa.pessoa_juridica.cnpj_digito)+" - "+obj.pessoa.pessoa_juridica.inscricao_estadual, value: obj.pessoa.pessoa_id })
          });
          this.isLoadingDest = false;
          // this.isLoadingTom2 = false;
        })
            .catch(errors =>
            {
              new ReturnApi(errors, this)
            });
      }
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    certificado_instalado: {
      get() {
        return this.$store.getters.certificado_instalado;
      },
    },
  },
};
</script>